import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import {Button} from '@chakra-ui/react';
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';

export function ScheduleGroupClassModal({group_id, language_name, level_name, setShowGroupScheduleModal, sessions_array}) {
  const [classSchedule, setClassSchedule] = useState([]);
  const {setTostMessage} = useContext(TostMessageContext);
  const {logOutFunction} = useContext(UserContext)
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const navigate = useNavigate();

  const setTime = async (time, day) => {
    const new_array = classSchedule;
    const index = new_array.findIndex(item => item.day === day);
    if (index !== -1) {
        // Update existing
        new_array[index] = {day: day, time: time};
    } else {
        // Add new
        new_array.push({day: day, time: time});
    }
    setClassSchedule(new_array);
  }

  const scheduleClasses = async () => {
    const formData = new FormData();
    formData.append('group_id', group_id);
    formData.append('schedule', JSON.stringify(classSchedule));
    setLoading(true);
    try {
        const response = await axios.post(base_url + '/classes/schedule-group-class.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoading(false);
            setTostMessage({
                messageType: "success",
                message: response.data.response,
            });
            setTimeout(() => {
                navigate("/my-classes");
            }, 1000)
        } else {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoading(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const week_days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 max-h-[60%] min-h-[350px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px]'>
                <div onClick={() => setShowGroupScheduleModal(false)} className='w-[80%] flex justify-end text-underline text-[#ff0000] cursor-pointer'>Cancel</div>
                <a className='text-dark text-[20px] font-bold'>Schedule Classes</a>
                <div className='w-[80%] mt-2 flex flex-col justify-start cursor-pointer'>
                    <a className='text-dark mx-auto text-[15px] font-semibold'>{language_name} ({level_name})</a>
                </div>
                <div className='w-[80%] mt-3 h-auto overflow-y-auto flex flex-col'>
                    {[...Array(7)].map((_, i) => (
                        <div key={i} className='my-2'>
                            <label>{week_days[i]}</label>
                            <input className='p-3 border border-1 w-full rounded-[5px] my-1' type="time" onChange={(e) => setTime(e.target.value, week_days[i])} />
                        </div>
                    ))}
                </div>
                <button
                    onClick={() => loading ? null : scheduleClasses()}
                    className="w-[80%] mt-3 mx-auto bg-yellow hover:bg-yellow-500 text-black font-medium py-2 rounded-md transition"
                >
                    {loading ? (
                        <ClockLoader
                            color={'#212121'}
                            loading={loading}
                            size={25}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            className='mx-auto'
                        />
                        ) : 'Schedule'
                    }
                </button>
                <a className='text-xs text-orange w-[60%] mt-3 mx-auto text-center'>Only fill in the day(s) you have class(es)</a>
            </div>  
        </div>
    )
}

